import * as React from "react";
import { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import { Alert, Button } from "components/bootstrap";
import { RingProgress } from "components/common";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import useSelectedDataLake from "data-lake/hooks/useSelectedDataLake";
const StyledAlert = styled(Alert)(
  ({ theme }) => css`
    padding: ${theme.spacings.xs};
    margin: 0;
    min-height: 45px;
  `
);
const InnerContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.spacings.sm};
  `
);
const LeftCol = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacings.sm};
  `
);
const StyledRingProgress = styled(RingProgress)`
  margin-bottom: -4px;
  margin-top: -4px;
`;
const ProgressInformation = ({ onCancel: onCancelProp = () => Promise.resolve(), progress }) => {
  const [isCancelingExecution, setIsCancelingExecution] = useState(false);
  const { selectedDataLake } = useSelectedDataLake();
  const sendTelemetry = useSendTelemetry("loading-indicator");
  const [isLongRunningSearch, setIsLongRunningSearch] = useState(false);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.DATALAKE.PREVIEW[selectedDataLake.type].SEARCH_TAKES_LONGER, {
        app_pathname: "/data-storage/preview",
        event_details: {
          data_lake_storage_type: selectedDataLake.storageType
        }
      });
      setIsLongRunningSearch(true);
    }, 1e4);
    return () => clearTimeout(timeoutId);
  }, [selectedDataLake.storageType, selectedDataLake.type, sendTelemetry]);
  const onCancel = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.DATALAKE.PREVIEW[selectedDataLake.type].CANCEL_SEARCH, {
      app_pathname: "/data-storage/preview",
      event_details: {
        data_lake_storage_type: selectedDataLake.storageType
      }
    });
    setIsCancelingExecution(true);
    onCancelProp().finally(() => {
      setIsCancelingExecution(false);
    });
  };
  return /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "info", noIcon: true }, /* @__PURE__ */ React.createElement(InnerContainer, null, /* @__PURE__ */ React.createElement(LeftCol, null, /* @__PURE__ */ React.createElement(StyledRingProgress, { sections: [{ value: progress, color: "info" }], size: 30, thickness: 4 }), /* @__PURE__ */ React.createElement("span", null, !isLongRunningSearch ? "We are retrieving your data lake messages. This may take a moment." : "This can take some time. You can leave this page and return later to view the results.")), /* @__PURE__ */ React.createElement(Button, { bsStyle: "default", bsSize: "small", onClick: onCancel }, isCancelingExecution ? "Canceling..." : "Cancel")));
};
export default ProgressInformation;
